import { FormattedMessage, useIntl } from "react-intl";
import React from "react";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";
import { Link, Navigate } from "react-router-dom";
import HeaderContainer from "../app/HeaderContainer";
import UserUtils from "../../utils/UserUtils";

const Login = ({ isLoggedIn, username, password, doLogin, role, usernameChanged, passwordChanged }) => {
  const intl = useIntl();

  return !isLoggedIn ? (
    <>
      <HeaderContainer />
      <Form className="signin" onKeyDown={(e) => e.key === "Enter" && doLogin()}>
        <Form.Group>
          <Form.Control
            value={username}
            onChange={(e) => usernameChanged(e.target.value)}
            autoComplete="off"
            placeholder={intl.formatMessage({ id: "login.placeholder.username" })}
            className="my-2"
          />
          <Form.Control
            value={password}
            type="password"
            onChange={(e) => passwordChanged(e.target.value)}
            autoComplete="off"
            placeholder={intl.formatMessage({ id: "login.placeholder.password" })}
            className="my-2"
          />
          <Link className="text-light" to="/forgotPassword">
            <FormattedMessage id="login.forgot.password" />
          </Link>
        </Form.Group>
        <Button onClick={doLogin} variant="primary">
          <FormattedMessage id="login.loginButton" />
        </Button>
      </Form>
    </>
  ) : (
    <Navigate to={UserUtils.getUserHome(role)} />
  );
};

Login.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  doLogin: PropTypes.func.isRequired,
  usernameChanged: PropTypes.func.isRequired,
  passwordChanged: PropTypes.func.isRequired,
  role: PropTypes.array
};

export default Login;
